import { render, staticRenderFns } from "./infoModal.vue?vue&type=template&id=34a13aa8&scoped=true"
import script from "./infoModal.vue?vue&type=script&lang=js"
export * from "./infoModal.vue?vue&type=script&lang=js"
import style0 from "./infoModal.vue?vue&type=style&index=0&id=34a13aa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a13aa8",
  null
  
)

export default component.exports